import { useEffect } from "react";
import type { DependencyList } from "react";

const useDebounce = (effect: any, delay: number, deps?: DependencyList) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // using || operator because
    // if its optional then it can be undefined.
  }, [...(deps || []), delay]);
};

export default useDebounce;
